import { AnyAction } from 'redux'
import { createSelector } from 'reselect'

const initialState: State.TaxonomyIdByFilterNameState = {}

export function reducer(state: State.TaxonomyIdByFilterNameState = initialState, action: AnyAction): State.TaxonomyIdByFilterNameState {
  switch (action.type) {
    default:
      return state
  }
}

export const taxonomyIdByFilterNameSelector = createSelector(
  (state: State.GlobalState) => state.taxonomyIdByFilterName,
  (taxonomyIdByFilterName) => (filterName: string) => taxonomyIdByFilterName[filterName],
)
